import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "E:\\PROJECT\\grasitech\\node_modules\\next\\dist\\client\\app-dir\\link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\PROJECT\\grasitech\\src\\components\\FloatingNav\\index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\PROJECT\\grasitech\\src\\data\\services\\jasa-instalasi-jaringan-cctv.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\PROJECT\\grasitech\\src\\data\\services\\jasa-instalasi-panel-surya.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\PROJECT\\grasitech\\src\\data\\services\\jasa-pembuatan-software.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "E:\\PROJECT\\grasitech\\src\\data\\services\\jasa-web-development.tsx");
